'use strict';

var React = require('react'),
    Rotator = require('../molecules/Rotator'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

var SearchNavHeader = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    scrolledPastZines: PropTypes.bool.isRequired,
    scrolledPastUsers: PropTypes.bool.isRequired,
    scrolledPastStamps: PropTypes.bool.isRequired
  },

  render() {
    var activeIndex;
    if (this.props.scrolledPastStamps) {
      activeIndex = 3;
    } else if (this.props.scrolledPastUsers) {
      activeIndex = 2;
    } else if (this.props.scrolledPastZines) {
      activeIndex = 1;
    } else {
      activeIndex = 0;
    }

    return (
      <Rotator activeIndex={activeIndex}>
        <span />
        <span>Matching Collections</span>
        <span>Matching Users</span>
        <span>Matching Stamps</span>
      </Rotator>
    );
  }
});

module.exports = SearchNavHeader;



/** WEBPACK FOOTER **
 ** ./molecules/SearchNavHeader.jsx
 **/